import axios from 'axios';
import backendURLs from '../../misc/backendURLs';

export default (token) => {
  return axios
    .post(backendURLs.reCaptcha, { token })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
};
